import React from 'react';
import { ThemeProvider } from 'styled-components';
import usePriorityMatch from './hooks/usePriorityMatch';
import MatchTopRow from './components/MatchTopRow/MatchTopRow';
import MatchupRow from './components/MatchupRow/MatchupRow';
import useModuleImpression from '../shared/hooks/useModuleImpression';
import { Theme, themeTypes } from '../shared/styled/Theme';
import { trackModuleClick } from '../../libraries/_modules/tracking/helpers';

function PriorityMatch({ options }) {
  const { matchSlug, matchSportecId, position, analyticsLocation, sponsor } =
    options || {};

  const {
    isReady,
    matchStatus,
    homeAbbreviation,
    homeLogoUrl,
    homeBackgroundColor,
    homeGoals,
    awayAbbreviation,
    awayLogoUrl,
    awayBackgroundColor,
    awayGoals,
    showScore,
    hasHighlights,
    appleStreamURL,
    highlightsUrl,
    matchPageUrl,
    leaguePromoImageUrl,
    minutes,
    extraMinutes,
    dateLabel,
    matchTime,
    isTimeTbd,
    leagueMatchTitle,
  } = usePriorityMatch({ matchSportecId, matchSlug });

  const trackingData = {
    module_type: 'priority_match',
    match_id: matchSportecId,
    match: matchSlug,
    position: position,
    location: analyticsLocation || '',
    sponsor: sponsor || '',
    platform: 'web',
    domain: window.location.href,
  };

  const impressionRef = useModuleImpression(trackingData, { enabled: isReady });

  const handleModuleClick = (event) => {
    if (event.target.closest('a') || !matchPageUrl) {
      return;
    }

    trackModuleClick(trackingData);
    window.location.href = matchPageUrl;
  };

  if (!isReady) return null;

  return (
    <ThemeProvider
      theme={{ ...Theme, type: options?.theme || themeTypes.light }}
    >
      <div
        ref={impressionRef}
        role="region"
        className="mls-c-priority-match"
        onClick={handleModuleClick}
      >
        <MatchTopRow
          sponsorImageUrl={leaguePromoImageUrl}
          matchStatus={matchStatus}
          minutes={minutes}
          extraMinutes={extraMinutes}
          dateLabel={dateLabel}
          matchTime={matchTime}
          isTimeTbd={isTimeTbd}
          leagueMatchTitle={leagueMatchTitle}
        />
        <MatchupRow
          homeAbbreviation={homeAbbreviation}
          homeLogoUrl={homeLogoUrl}
          homeBackgroundColor={homeBackgroundColor}
          homeGoals={homeGoals}
          awayAbbreviation={awayAbbreviation}
          awayLogoUrl={awayLogoUrl}
          awayBackgroundColor={awayBackgroundColor}
          awayGoals={awayGoals}
          showScore={showScore}
          matchStatus={matchStatus}
          appleStreamURL={appleStreamURL}
          hasHighlights={hasHighlights}
          highlightsUrl={highlightsUrl}
          matchPageUrl={matchPageUrl}
          slug={matchSlug}
          position={position}
          matchId={matchSportecId}
          location={analyticsLocation || ''}
          sponsor={sponsor || ''}
        />
      </div>
    </ThemeProvider>
  );
}

// eslint-disable-next-line no-func-assign
PriorityMatch = React.memo(PriorityMatch);

export default PriorityMatch;
